import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import PrivateRoute from './components/PrivateRoute';
import DevicePage from './components/Devices/DevicePage';
import ServicesPage from './components/Service/ServicesPage';
import UserProfilePage from './components/UserProfilePage';
import LoginPage from './components/LoginPage';
import GitAdminPage from './components/GitAdmin/GitAdminPage';
import ToolsPage from './components/Tools/ToolsPage';
import SessionLoginOauth from './components/session/LoginOauth';
import Layout from 'components/common/layout';

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/session/loginOAuth" element={<SessionLoginOauth />} />
          <Route element={<PrivateRoute />}>
            <Route path="/git-admin" element={<GitAdminPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/devices" element={<DevicePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/profile" element={<UserProfilePage />} />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
